import type { Option } from '@/modules/common/types/option.type.ts';

export type CounterpartyNameForm = {
  type: Option<number> | null;
  name: string;
  code: string;
  inn: string;
  legalForm: Option | null;
  kpp: string;
  ogrn: string;
  okpo: string;
  okato: string;
};

export function createEmptyNameForm(): CounterpartyNameForm {
  return {
    type: null,
    name: '',
    code: '',
    inn: '',
    legalForm: null,
    kpp: '',
    ogrn: '',
    okpo: '',
    okato: '',
  };
}
